<template>
	<div :class="`relative ${full ? 'grow' : ''} max-w-full flex items-center`">
		<div class="absolute px-2 py-1 flex items-center">
			<i :class="iconClass"/>
		</div>
		<GenericInput type="number" :min="min ?? 0" :max="max ?? 4294967296" :step="step ?? 1" :value="modelValue" :full="full" class="pl-8! pr-2! py-1! max-w-full" @update:value="updateValue"/>
	</div>
</template>
<script setup lang="ts">
import {defineEmits, defineProps} from 'vue'
import GenericInput from '@/Components/UI/Inputs/GenericInput.vue'

defineProps<{
	iconClass:string,
	modelValue:number,
	min?:number,
	max?:number,
	step?:number,
	full?:boolean,
}>()

const emit = defineEmits([
	'update:modelValue',
])

function updateValue(newValue: number): void{
	emit('update:modelValue', newValue)
}
</script>
